import { Compass, ShieldCheck, Handshake, Clock, Languages, Globe2 } from "lucide-react";

const PILLARS = [
  {
    icon: Compass,
    title: "Hyper-Local Knowledge",
    body: "Schools, flood zones, HOA quirks, micro-markets — Okaloosa, Walton & Santa Rosa are my home court.",
  },
  {
    icon: ShieldCheck,
    title: "Dual-Licensed",
    body: "Licensed Realtor and Mortgage Loan Originator — one accountable advisor.",
  },
  {
    icon: Globe2,
    title: "Nationwide + Puerto Rico",
    body: "My team is licensed to lend across all 50 U.S. states and Puerto Rico — wherever your next property is.",
  },
  {
    icon: Languages,
    title: "20 Languages",
    body: "A multilingual team that can serve clients comfortably in 20 different languages.",
  },
  {
    icon: Handshake,
    title: "Non-QM Specialist",
    body: "DSCR, Bank Statement, HELOC, Jumbo — financing for clients banks turn away.",
  },
  {
    icon: Clock,
    title: "Responsive & Real",
    body: "Calls answered. Texts returned. Updates on time. No black boxes.",
  },
];

export default function Expertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="relative py-24 md:py-32 bg-ink text-white overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <p className="overline text-brass">Why Work With J.J.</p>
            <h2 className="mt-5 font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Quiet expertise.
              <br />
              <span className="italic text-brass">Loud results.</span>
            </h2>
            <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed max-w-md">
              You deserve an advisor who knows the streets, the lenders, and the
              difference one timely decision can make.
            </p>
          </div>

          <ul className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <li key={p.title} className="flex gap-4">
                  <span className="flex-shrink-0 mt-1 w-10 h-10 rounded-full border border-brass/40 inline-flex items-center justify-center">
                    <Icon className="w-4 h-4 text-brass" />
                  </span>
                  <div>
                    <h3 className="font-display text-white text-2xl tracking-tight">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-white/70 text-sm leading-relaxed">
                      {p.body}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
